<p-card>
  <div class="header">{{title}}</div>
  <p-chart type="line" [data]="chartData" [options]="options"></p-chart>
  <div class="footer">{{footer}}</div>
</p-card>